import constants from 'constants/index'

const { STRING_SCHEMA_TYPE, ALPHANUMERIC_REGEX } = constants.validations

const alphanumeric = {
  name: 'alphanumeric',
  schemaType: STRING_SCHEMA_TYPE,
  method(message = 'Deve conter apenas letras e números') {
    return this.matches(ALPHANUMERIC_REGEX, {
      message,
      excludeEmptyString: true,
    })
  },
}

export default alphanumeric
